import { useEffect, useContext } from "react";

import PermissionContext from "../../../context/PermissionContext";
import DrawerContext from "../../../context/DrawerContext";
import AutoLogout from "../../../utils/useAutoLogout";
import BufferContext from "../../../context/materialcapture/BufferContext";

import Box from "@mui/material/Box";
import Typography from '@mui/material/Typography';

import SideDrawer from "../../../components/layout/SideDrawer";
import SuccessAlert from "../../../components/layout/SuccessAlert";
import Loader from "../../../components/layout/Loader";
import ErrorModal from "../../../components/layout/ErrorModal";
import TopBarWithBack from "../../../components/layout/TopBarWithBack";
import BufferForm from "../../../components/materialscapture/BufferForm";
import RawMaterialsFooter from "../../../components/materialscapture/RawMaterialFooter";
import BufferComponetForm from "../../../components/materialscapture/BufferComponentForm";

const BufferCreatePage = () => {
  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);
  const { 
    bufferComponentArray, handleComponentAdd, handleSubmit, apiRes, setApiRes 
  } = useContext(BufferContext);

  const backURL = '/buffers';

  useEffect(() => {
    if(permisionsList.length > 0) checkUserPermission(['Materials Capture-Buffers']);
  }, [permisionsList]);

  return(
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      {apiRes.loading && <Loader />}
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}
        <TopBarWithBack title={'Buffer Create'} backURL={backURL} />
        <BufferForm type='Create' />

        <Box sx={{display: 'flex', mt: 1}}>
          <Typography
            color='text.secondary'
            variant='h6'
          >
            <strong>Components: {bufferComponentArray.length}</strong>
          </Typography>
        </Box>

        {
          bufferComponentArray.map((data, index) => (
            <BufferComponetForm key={index} index={index} data={data} />
          ))
        }
        <RawMaterialsFooter 
          btnText={'Component'} 
          handleAdd={handleComponentAdd} 
          handleSubmit={handleSubmit} 
        />
        <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
      </div>
    </AutoLogout>
  );
};

export default BufferCreatePage;